import { WritingToolsJWT } from '@src/state/auth/types'

export function parseJwt(token: string): WritingToolsJWT {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64)) as WritingToolsJWT
  } catch (error) {
    throw new Error(`Cannot parse invalid jwt string: ${JSON.stringify(error)}`)
  }
}



// WEBPACK FOOTER //
// ./src/utils/jwt.ts